<template>
  <ElAlert
    :closable="false"
    type="error"
    class="budget-error"
    :title="$t('ADVERTISEMENT.BUDGET_ERROR.TITLE')"
  >
    <div class="row">
      <div class="columns">
        {{ $t('ADVERTISEMENT.BUDGET_ERROR.DESCRIPTION') }}
      </div>
      <div>
        <RouterLink :to="{ name: 'finance-transactions' }">
          {{ $t('ADVERTISEMENT.BUDGET_ERROR.ADD_TO_WALLET') }}
        </RouterLink>
      </div>
    </div>
  </ElAlert>
</template>

<script>
export default {
  name: 'BudgetError',
};
</script>

<style lang="scss">
.budget-error {
  .el-alert {
    &__content {
      width: 100%;
    }
  }
}
</style>
